(ns common.datascript.init
  (:require [cljs.pprint :refer [pprint]]
            [common.datascript.schema :refer [schema]]
            [common.datascript.sequence :refer [init-sequence-abstraction]]
            [datascript.core :as d]
            [re-posh.core :as rp]))

(defn- init []
  (doto (d/create-conn schema)
    #_
    (d/listen! ::debug (fn [{:keys [db-before
                                    db-after
                                    tx-data
                                    tempids
                                    tx-meta]}]
                         (pprint {:tempids tempids
                                  :tx-data tx-data})))
    (rp/connect!)
    (init-sequence-abstraction)))

(defonce conn (init))

(defn init-tests []
  (init))

(comment
  (d/datoms @conn :eavt)
  (count *1)
  (d/listen! conn ::debug (fn [x] (pprint x)))
  (d/unlisten! conn ::debug)
  ,)
